import React, { useState, useEffect, useRef, useCallback } from "react";
import MaterialTable from "material-table";
import { format } from "date-fns";
import { CSVLink } from "react-csv";
import Swal from "sweetalert2";
import { Spinner } from "react-bootstrap";
import { deleteRoleById, getAllRole, updateRoleById } from "../../../api/roleApi";
import { useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import RoleFormPage from "./RoleFormPage";
import { Box, Button, IconButton } from "@material-ui/core";
import { Close } from "@material-ui/icons";

const RoleListPage = () => {
    const dateToday = format(new Date(), "dd-MM-yyyy HH-mm");
    const controllerRef = useRef(null);

    // global redux state
    const { thisMenuPermission } = useSelector(state => {
        const { menuPermission } = state?.menu;
        return {
            thisMenuPermission: menuPermission?.find(menu => menu?.path === window.location.pathname)?.permission,
        };
    });

    // component state
    const [loading, setLoading] = useState(false);
    const [dataRoleUser, setDataRoleUser] = useState([]);
    const [datacsv, setDataCsv] = useState([]);
    const [propsModalPermission, setPropsModalPermission] = useState({ isOpen: false, id: undefined });

    const getData = useCallback(async signal => {
        try {
            setLoading(true);
            const data_role = await getAllRole(signal);
            if (data_role) {
                setDataRoleUser(data_role);

                const mock_csv = [];
                // eslint-disable-next-line
                await data_role.map((item, index) => {
                    item.numberdata = index + 1;
                    mock_csv.push({
                        number: index + 1,
                        group_name: item?.roleName,
                        amount_user: item?.Users?.length,
                        status: item?.status === 1 ? "open" : "close",
                    });
                });
                setDataCsv(mock_csv);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        controllerRef.current = new AbortController();
        const fetch = async () => {
            getData(controllerRef.current?.signal);
        };
        fetch();
        return () => {
            controllerRef.current.abort();
        };
    }, [getData]);

    const deleteData = async role_id => {
        Swal.fire({
            heightAuto: false,
            title: "Are you sure?",
            text: "If sure, press OK.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "ok",
            cancelButtonText: "cancel",
            allowOutsideClick: false,
        }).then(async result => {
            if (result.isConfirmed) {
                const isDeleteRole = await deleteRoleById(role_id, controllerRef.current?.signal);
                if (isDeleteRole) {
                    getData();
                } else {
                    Swal.fire({
                        icon: "error",
                        title: "Error!",
                        text: "Please try again",
                    });
                }
            }
        });
    };

    const handleOpenModalForm = useCallback(({ id = undefined }) => {
        setPropsModalPermission(prev => ({ isOpen: true, id }));
    }, []);
    const handleCloseModalForm = () => {
        setPropsModalPermission({ id: undefined, isOpen: false });
    };

    // const editData = async data_edit => {
    //     history.replace(`/user_role_management/role_form/${data_edit?.id}`);
    // };

    // const insertData = async () => {
    //     history.replace("/user_role_management/role_form");
    // };

    const clickStatusOff = async id => {
        const isUpdateRole = await updateRoleById(id, { status: 0 }, controllerRef.current?.signal);
        if (isUpdateRole) {
            getData();
        }
    };

    const clickStatusOn = async id => {
        const isUpdateRole = await updateRoleById(id, { status: 1 }, controllerRef.current?.signal);
        if (isUpdateRole) {
            getData();
        }
    };

    if (loading === true) {
        return (
            <div className="text-center mt-5">
                <Spinner animation="border" variant="primary" />
            </div>
        );
    }

    return (
        <div className="row">
            <div className="col-12 mb-2">
                <div className="card-header">
                    <div className="card-title">
                        <div className="row">
                            {thisMenuPermission?.create && (
                                <div className="col-12">
                                    <Button
                                        type="button"
                                        className="btn t-btn-primary float-right mb-2"
                                        style={{ minWidth: 100 }}
                                        onClick={() => handleOpenModalForm({ id: undefined })}>
                                        <i className="far fa-plus-square icon-md" style={{ color: "inherit" }}></i>
                                        CREATE
                                    </Button>
                                </div>
                            )}
                            <div className="col-12">
                                <Button style={{ minWidth: 100 }} className="btn t-btn-gray float-right">
                                    <CSVLink
                                        data={datacsv}
                                        filename={`ReportListRole ${dateToday}`}
                                        target="_blank"
                                        style={{ color: "inherit" }}>
                                        <i className="fas fa-file-export icon-md" style={{ color: "inherit" }}></i>
                                        EXPORT
                                    </CSVLink>
                                </Button>
                            </div>
                        </div>
                    </div>
                    <div className="card-body" style={{ padding: 0 }}>
                        <div className="t-table-custom p-lg-10 p-5">
                            <MaterialTable
                                components={{ Container: Box }}
                                title="Role - Listing"
                                columns={[
                                    {
                                        title: "#",
                                        field: "id",
                                        editable: "never",
                                        render: rowData => {
                                            return rowData?.numberdata;
                                        },
                                    },
                                    {
                                        title: "Role Name",
                                        field: "roleName",
                                        editable: "never",
                                        render: rowData => {
                                            return rowData?.roleName;
                                        },
                                    },
                                    {
                                        title: "Users",
                                        field: "Users",
                                        editable: "never",
                                        render: rowData => {
                                            return rowData?.Users?.length;
                                        },
                                    },
                                    {
                                        title: "Status",
                                        field: "status",
                                        lookup: { false: "active", true: "suspended" },
                                        render: rowData => {
                                            if (rowData?.status) {
                                                return (
                                                    <span
                                                        className="label label-inline label-light-success font-weight-bold pointer"
                                                        onClick={() => clickStatusOff(rowData?.id)}>
                                                        open
                                                    </span>
                                                );
                                            } else {
                                                return (
                                                    <span
                                                        className="label label-inline label-light-danger font-weight-bold pointer"
                                                        onClick={() => clickStatusOn(rowData?.id)}>
                                                        close
                                                    </span>
                                                );
                                            }
                                        },
                                    },
                                ]}
                                data={dataRoleUser}
                                actions={[
                                    {
                                        icon: "edit",
                                        iconProps: { style: { fontSize: 18 }, className: "action-edit" },
                                        tooltip: "Edit",
                                        onClick: (event, rowData) => {
                                            // Do save operation
                                            handleOpenModalForm({ id: rowData.id });
                                        },
                                        hidden: !thisMenuPermission?.edit,
                                    },
                                    {
                                        icon: "delete",
                                        iconProps: { style: { fontSize: 18 }, className: "action-delete" },
                                        tooltip: "Delete",
                                        onClick: (event, rowData) => deleteData(rowData.id),
                                        hidden: !thisMenuPermission?.delete,
                                    },
                                ]}
                                options={{
                                    pageSize: 20,
                                    pageSizeOptions: [5, 10, 20, 50],
                                    actionsColumnIndex: -1,
                                    emptyRowsWhenPaging: false, // To avoid of having empty rows
                                    headerStyle: {
                                        fontSize: 15,
                                    },
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-12">
                <Modal size="xl" scrollable show={propsModalPermission.isOpen} onHide={handleCloseModalForm}>
                    <Modal.Header>
                        <Modal.Title>Form</Modal.Title>
                        <IconButton onClick={handleCloseModalForm}>
                            <Close />
                        </IconButton>
                    </Modal.Header>
                    <Modal.Body>
                        <RoleFormPage id={propsModalPermission.id} handleCloseModalForm={handleCloseModalForm} />
                    </Modal.Body>
                </Modal>
            </div>
        </div>
    );
};

export default RoleListPage;
